export default __webpack_public_path__ + "static/media/newegg.6583cce3.png";